import VCFundDetails from "./VCFundDetails";

export default VCFundDetails;
